import { render, staticRenderFns } from "./add_bis.vue?vue&type=template&id=214319e8"
import script from "./add_bis.vue?vue&type=script&lang=ts"
export * from "./add_bis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports